import {
  Breadcrumbs,
  CircularProgress,
  Link,
  Typography,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import SortableTable from "../../../Components/SortableTable";
import Title from "../../../Components/Title";
import { getDevices } from "../../../Utils/ApiCalls";
import {
  DEVICE_SEARCH_ID,
  ECABIN,
  formatTimeWithTZOffset,
  getDeviceType,
  getFromStorage,
  saveToStorage,
} from "../../../Utils/Common";
import { useStyles } from "../../../Utils/Styles";

const getDeviceSearchText = (device) =>
  [
    device?.serialNumber,
    device?.deviceName,
    device?.version,
    device?.model,
    device?.location,
    device?.macAddress,
    device?.teamviewerId,
    device?.Company?.name,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

function search(devices, searchValue) {
  const normalizedSearch = (searchValue || "").toLowerCase();
  if (!normalizedSearch) {
    return devices || [];
  }
  return (devices || []).filter((device) =>
    getDeviceSearchText(device).includes(normalizedSearch),
  );
}

export default function AdminDevices(props) {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const [devices, setDevices] = useState();
  const [searchList, setSearchList] = useState();
  const [searchValue, setSearchValue] = useState();
  const [defSearchVal, setDefSearchVal] = useState();

  const showDevice = (id) => {
    history.push("/cpanel/devices/" + id.id);
  };

  const showDeviceNewTab = (event, id) => {
    window.open("/cpanel/devices/" + id.id, "_blank");
  };

  useEffect(() => {
    getDevices({ view: "list", requireLCS: false }, (result) => {
      if (!result.error) {
        const deviceList = result.devices || [];
        setDevices(deviceList);
        setSearchList(search(deviceList, searchValue));
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (devices) {
      setSearchList(search(devices, searchValue));
    }
  }, [searchValue, devices]);

  useEffect(() => {
    var x = getFromStorage(DEVICE_SEARCH_ID);
    setDefSearchVal(x);
    if (x !== null) {
      setSearchValue(x);
    }
  }, []);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            color="inherit"
            style={{ cursor: "pointer" }}
            onClick={() => {
              history.push("/cpanel/devices/dashboard");
            }}
          >
            {t("devices.header")}
          </Link>
          <Typography>{t("search")}</Typography>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          {defSearchVal === undefined ? null : (
            <TextField
              autoFocus
              label={t("devices.search")}
              margin="dense"
              type="text"
              fullWidth
              size="medium"
              value={searchValue || ""}
              onChange={(e) => {
                setSearchValue(e.target.value.toLowerCase());
                saveToStorage(DEVICE_SEARCH_ID, e.target.value.toLowerCase());
              }}
            />
          )}
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Title>{t("deviceList.header")}</Title>
          {searchList ? (
            <SortableTable
              headCells={[
                {
                  id: "serialNumber",
                  numeric: false,
                  disablePadding: false,
                  label: t("deviceList.serial"),
                },
                {
                  id: "model",
                  numeric: false,
                  disablePadding: false,
                  label: t("deviceList.model"),
                },
                {
                  id: "version",
                  numeric: false,
                  disablePadding: false,
                  label: t("deviceList.version"),
                },
                {
                  id: "deviceName",
                  numeric: false,
                  disablePadding: false,
                  label: t("deviceList.name"),
                },
                {
                  id: "location",
                  numeric: false,
                  disablePadding: false,
                  label: t("deviceList.location"),
                },
                {
                  id: "macAddress",
                  numeric: false,
                  disablePadding: false,
                  label: "MACAddress",
                },
                {
                  id: "teamviewerId",
                  numeric: false,
                  disablePadding: false,
                  label: "TeamViewerID",
                },
                {
                  id: "deviceType",
                  numeric: false,
                  disablePadding: false,
                  label: t("deviceList.type"),
                },
                {
                  id: "Company.name",
                  numeric: false,
                  disablePadding: false,
                  label: t("deviceList.company"),
                },
                {
                  id: "lastActivity",
                  numeric: false,
                  disablePadding: false,
                  label: "Online",
                },
              ]}
              defaultSortRow={"serialNumber"}
              handleRowClick={showDevice}
              handleScrollClick={showDeviceNewTab}
              tableData={searchList}
              rowsPerPage={50}
              specialDataFormatting={[
                {
                  id: "deviceType",
                  format: (data, b, con) => {
                    return getDeviceType(con.serialNumber);
                  },
                },
                {
                  id: "lastActivity",
                  format: (data) => {
                    return formatTimeWithTZOffset(data, ECABIN);
                  },
                },
              ]}
            />
          ) : (
            <CircularProgress />
          )}
        </Paper>
      </Grid>
    </Grid>
  );
}
